export const getOrCreateUserId = (storageKey = 'vote_authorId') => {
  // return 350147805;
  let userId = localStorage.getItem(storageKey);

  if (!userId) {
    const min = 10000000000;
    const max = 99999999999;
    userId = String(Math.floor(Math.random() * (max - min + 1)) + min);
    localStorage.setItem(storageKey, userId);
  }

  return userId;
};
